import { DataObject, ScanDataObject, ThumbnailDataObject } from "@/typed/CaseStateData";
import { ModelLabel } from "@/typed/ModelTypes";
import { ThumbnailFileTypes } from "@/typed/ThumbnailFileTypes";
import { createWorkerPool } from "@/worker/common";
import { bufferGeometryFromGeometry, GenerateGeometryFromDataMessage, GenerateThumbnailFromData, Geometry } from "@/worker/geometry";
import GeometryWorker from "@/worker/geometry?worker";
import * as THREE from "three";

const sendDataToGeometryPool = createWorkerPool<GenerateGeometryFromDataMessage, Geometry | undefined, THREE.BufferGeometry | undefined>(
  GeometryWorker,
  (data: Geometry | undefined) => {
    if (data === undefined) {
      return undefined;
    }

    return bufferGeometryFromGeometry(data);
  }
);

const sendDataToThumbnailPool = createWorkerPool<GenerateThumbnailFromData, ArrayBuffer | undefined, ArrayBuffer | undefined>(
  GeometryWorker,
  (data) => data
);

export const parseDataToGeometry = (data: (ScanDataObject | DataObject)[]) =>
  sendDataToGeometryPool({
    message: {
      kind: "geometryFromData",
      data: data
    }
  });

export const generateModelThumbnail = async (scans: (ScanDataObject | DataObject)[]): Promise<ThumbnailDataObject> => {
  const data = await sendDataToThumbnailPool({
    message: {
      kind: "thumbnailFromData",
      data: scans
    }
  });
  if (data === undefined) {
    const emptyThumbnail: ThumbnailDataObject = {
      data: null,
      label: "" as ModelLabel,
      type: "png" as ThumbnailFileTypes
    };
    return emptyThumbnail;
  }

  const thumbnail: ThumbnailDataObject = {
    data,
    label: "" as ModelLabel,
    type: "png" as ThumbnailFileTypes
  };
  if (scans.length == 1) {
    thumbnail.label = scans[0].label;
  } else if (scans.length > 1) {
    thumbnail.label = "combined" as ModelLabel;
  }

  return thumbnail;
};
